import UNLOX from "@/assets/logo/unlox.png";
import Nephro from "@/assets/logo/nephro.png";
import mahindra from "@/assets/logo/mahindra.webp";
import Student1 from "@/assets/students/anil-sharma.png";
import Student2 from "@/assets/students/doma-tamang.png";
import Student3 from "@/assets/students/heema.png";
import Student4 from "@/assets/students/kristina-thatal.png";

export const PLACEMENTS_DATA = [
  {
    name: "Srinu Rai",
    title: "Apprentice in F&B Department",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/taj_logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Emeyc_placement_srinu_rai.webp",
  },
  // {
  //   name: "Ankit Chettri",
  //   title: "Full Stack Engineer",
  //   companyLogo:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/emeyc.jpg",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Emeyc_placement_ankit_chettri.jpg",
  // },
  {
    name: "Doma Tamang",
    title: "Junior Dialysis Therapist",
    companyLogo: Nephro,
    image: Student2,
  },
  {
    name: "Heema",
    title: "Business Development Associate",
    companyLogo: UNLOX,
    image: Student3,
  },
  
  // {
  //   name: "Amos Lohar ",
  //   title: "Trainee-Optometrist",
  //   companyLogo:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/lenskart-logo.png",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/amos-lohar.jpeg",
  // },
  {
    name: "Bindhia Gurung",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/bindiya.jpg",
  },
  {
    name: "Tigina Subba",
    title: "Junior Dialysis Therapist",
    companyLogo: Nephro,
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Nephroplus+-+Tigina+-+Joined+-+Final+Placement+.jpeg",
  },
  {
    name: "Adrash Thapa",
    title: "Management Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/adarsh.png",
  },
  // {
  //   name: "Kristina Thatal",
  //   title: "Junior Dialysis Therapist",
  //   companyLogo: Nephro,
  //   image: Student4,
  // },
  {
    name: "Dil Bahadur Limboo",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/dil+bahadur.jpg",
  },
  {
    name: "Naresh Sharma",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/naresh.jpg",
  },
  {
    name: "Anil Sharma",
    title: "Business Development Associate",
    companyLogo: UNLOX,
    image: Student1,
  },
  {
    name: "Tshering Ongmu Sherpa",
    title: "Management Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/ongmu.JPG",
  },

  {
    name: "Reena Gurung",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/reena+gurung.jpg",
  },
  // {
  //   name: "Roshna Chettri",
  //   title: "Sales Consultant",
  //   companyLogo: mahindra,
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Rajsons+Motors+-+Full+time+placement+-+Roshna+Chettri+.webp",
  // },
  {
    name: "Puja Limboo",
    title: "Management Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/puja.jpg",
  },
  {
    name: "Regina Gurung",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/regina.jpg",
  },
  {
    name: "Bhupal Nepal",
    title: "NAPS Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/BHUPAL+NEPAL.jpg",
  },
  {
    name: "Ayush Thapa",
    title: "NAPS Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/AYUSH+THAPA.jpg",
  },
  {
    name: "Chunkila",
    title: "Junior Dialysis Therapist",
    companyLogo: Nephro,
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Nephroplus+-++Chunkila+-+Joined+-+Final+Placement++.jpeg",
  },
  {
    name: "Sanjeena Chettri",
    title: "Resort Executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sanjana-chettri-placement.jpeg",
  },
  {
    name: "Sima Darjee",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/sima.jpg",
  },
  // {
  //   name: "Laku Tamang ",
  //   title: "Junior Dialysis Therapist",
  //   companyLogo: Nephro,
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Nephroplus+-++Laku+-+Joined+-+Final+Placement+(1).jpg",
  // },
  {
    name: "Ringdak Raje",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/RINGDAK+RAJE.jpg",
  },
  {
    name: "Vikas Kumar",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/VIKASH+KUMAR.jpg",
  },
  {
    name: "Sabina Sharma",
    title: "Junior Dialysis Therapist",
    companyLogo: Nephro,
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Nephroplus+-+Sabina+-+Joined+-+Final+Placement+.jpeg",
  },
  {
    name: "Sujana Chettri",
    title: "Resort executive Trainee",
    companyLogo:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/sterling-logo.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/sanjeena.JPG",
  },
  // {
  //   name: "Satish Rai",
  //   title: "Digital Marketing Executive",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/PLacewell.webp",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Satish+Rai+Digital+Marketing+at+Placement+Retails.webp",
  // },
  // {
  //   name: "Balaram Sharma",
  //   title: "Web Developer",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/PLacewell.webp",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Balaram+Sharma+Web+Developer+at+Placement+Retail.webp",
  // },
  {
    name: "Biren Subba",
    title: "NAPS Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/BIREN+SUBBA.jpg",
  },
  {
    name: "Nipun Rai",
    title: "IT Assistant",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/emeyc.webp",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Nipun+Rai-+Company_+unlox++-+Business+Development+Associate++-+Nipun-2026-+BCA+-+Location+_+Bangalore+(1).webp",
  },
  // {
  //   name: "Palzor Pakhrin",
  //   title: "Digital Marketing Executive",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/PLacewell.webp",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Palzor+Pakhrin+Digital+Marketing+at+Placement+Retails.webp",
  // },
  // {
  //   name: "Dewas Sharma",
  //   title: "Quality Assurance Tester",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/ralakde.png",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Dewas+Sharma+as+Quality+Assurance+Tester+at+Ralakde+Pvt+Ltd.webp",
  // },
  {
    name: "Anusha Chettri",
    title: "IT Assisant",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/emeyc.webp",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Anusha+Chettri+IT+Assistant+at+EMEYC+.webp",
  },
  {
    name: "Prakhar",
    title: "IT Assisant",
    companyLogo: "",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Prakhar+-+Raginnee+Goyal+as+Intern+.webp",
    companyName: "Raginee Goyal Associates"
  },
  // {
  //   name: "Sujal",
  //   title: "Intern",
  //   companyLogo: "",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Sujal+-+Raginnee+Goyal+as+Intern+.webp",
  //   companyName:"Raginee Goyal Associates"
  // },
  {
    name: "Muskan Lamichanay",
    title: "Web Development Intern",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Bolds+Innovation.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Muskan+Lamichanay+as+Web+Development+Intern+at+Bolds+Innovation+(1).webp",
  },
  {
    name: "Bhaichung Galet Tamang",
    title: "NAPS Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/BHAICHUNG+GALEY+TAMANG.jpg",
  },
  // {
  //   name: "Karan Chettri",
  //   title: "Quality Assurance Tester",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/ralakde.png",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Karan+Chettri+as+Quality+Assurance+Tester+at+Ralakde+Pvt+Ltd.webp",
  // },
  {
    name: "Shristika Rai",
    title: "Chief Business Manager",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/indusind_nippon.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Shristika+Rai+Chief+Business+Manager+at+Indusind+Nippon+Life.webp",
  },
  //   {
  //   name: "Bhaichung Galet Tamang",
  //   title: "NAPS Trainee",
  //   companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/BHAICHUNG+GALEY+TAMANG.jpg",
  // },
  {
    name: "Rakesh Rai",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "  https://cdn.msu.edu.in/msu-reavamp/images/Placement/Rakesh_rai.jpg",
  },
  {
    name: "Saroj Pradhan",
    title: "Office Executive",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/bytesberry.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Saroj+Pradhan+as+Office+Executive+at+Bytesberry+Technologies.webp",
  },
  {
    name: "Sabinay Rai",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/SABINAY.jpg",
  },
  {
    name: "Pratikcha Pradhan",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/PRATIKCHA+PRADHAN.jpg",
  },
  {
    name: "Vishika Pradhan",
    title: "Chief Business Manager",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/indusind_nippon.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Vishika+Pradhan+as+Chief+Business+Manager+at+Indusind+Nippon+life.webp",
  },
  // {
  //   name: "Subodh Sharma",
  //   title: "Busniess Development Associate",
  //   companyLogo: UNLOX,
  //   image:
  //     "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Subodh+Sharma+unlox+-+Business+Development+Associate+-2026+-+BCA+-+Bangalore.webp",
  // },
  {
    name: "Saima Bisukarma",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/SAIMA.jpg",
  },
  {
    name: "Reejena Gurung",
    title: "Management Trainee",
    companyLogo: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Chai_point.png",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/REEJENA+GURUNG.jpg",
  }
];
